import { Drawer, Stack } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { useContext } from "react";
import { DRAWER_WIDTH } from "src/assets/data/initialData";
import useGetWebMenuList from "../../services/sidebarDashboard/useGetWebMenuList";
import AquaticSection from "./aquaticSection/AquaticSection";
import ChainSection from "./chainSection/ChainSection";
import ProfessionalSidebarSection from "./professionalSection/ProfessionalSidebarSection";
import SystemSection from "./systemSection/SystemSection";
import TraceabilitySection from "./traceabilitySection/TraceabilitySection";
// import UsefulSection from "./usefulSection/UsefulSection";
import { UserContext } from "src/contexts/UserContext";
import UsefulSection from "./usefulSection/UsefulSection";

const Sidebar = () => {
  const { businessID, userType } = useContext(UserContext);
  const { feedkback, data, loading: listLoading, refetch } = useGetWebMenuList(businessID ? businessID : null);

  // useEffect(() => {
  //   //refetch();
  // }, [isLoggedin]);

  return (
    <Drawer
      variant="permanent"
      anchor="right"
      sx={{
        width: DRAWER_WIDTH,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          backgroundColor: (theme) =>
            theme.palette.mode === "light" ? alpha(theme.palette.primary.main, 0.12) : theme.palette.grey.gb,
          width: DRAWER_WIDTH,
          boxSizing: "border-box",
          borderRadius: (theme) => `${theme.shape.borderRadius * 4}px`,
          py: 3,
          mx: 1.5,
          left: "0 !important",
          zIndex: "0 !important",
          "&::-webkit-scrollbar": {
            width: 0,
            background: "transparent",
          },

          scrollbarWidth: "none",
          "-ms-overflow-style": "none",
        },
      }}
    >
      {data?.getWebMenuList && (
        <Stack height="100%" justifyContent="space-between">
          {/*show three up menu tracing,chain,aqutic */}
          <Stack gap={1}>
            <TraceabilitySection menu={data?.getWebMenuList?.edges.filter((item) => item.node.webPosition === 1)} />
            <Stack>
              <ChainSection menu={data?.getWebMenuList?.edges.filter((item) => item.node.webPosition === 3)} />
              <AquaticSection
                menu={data?.getWebMenuList?.edges.filter(
                  // (item) => item.node.webPosition === 4 || (userType === "Admin" && item.node.webPosition === 5)
                  (item) => item.node.webPosition === 4
                )}
              />
            </Stack>
          </Stack>

          {/*show professional */}
          <ProfessionalSidebarSection
            // menu={data?.getWebMenuList?.edges.filter((item) => item.node.webPosition === 5 && userType !== "Admin")}
            menu={data?.getWebMenuList?.edges.filter((item) => item.node.webPosition === 5)}
          />
          {/*show butten menu setting and suporting */}
          <Stack spacing={1}>
            <UsefulSection
              menu={data?.getWebMenuList?.edges.filter(
                (item) => item.node.webPosition === 6 || item?.node?.menuName === "منوهای پرکاربرد"
              )}
            />
            <SystemSection menu={data?.getWebMenuList?.edges.filter((item) => item.node.webPosition === 2)} />
          </Stack>
        </Stack>
      )}
    </Drawer>
  );
};

export default Sidebar;
